import '../css/01.settings/fonts.css';
import '../css/02.generic/style.css';
import '../css/03.objects/container.css';
import '../css/03.objects/buttons.css';
import '../css/03.objects/measures.css';
import '../css/03.objects/section.css';
import '../css/03.objects/grid.css';
import '../css/03.objects/card.css';
import '../css/03.objects/forms.css';
import '../css/03.objects/texts.css';
import '../css/03.objects/tabs.css';
import '../css/03.objects/lists.css';
import '../css/04.components/header.css';
import '../css/04.components/cookies-consent.css';
import '../css/04.components/conclution.css';
import '../css/04.components/read-more.css';
import '../css/04.components/modal.css';
import '../css/04.components/footer.css';
import '../css/04.components/faq.css';
import '../css/04.components/socials.css';
import '../css/04.components/slider.css';
import '../css/05.trumps/backgrounds.css';
import '../css/05.trumps/custom.css';
import './func/lazyload-video.js';
import './func/faq.js';
import './func/readmore.js';
import './func/scrollto-top.js';
import './utils/cookies-consent.js';

import { initModal } from './func/modal';
import handleFormSubmit from './func/contact-form.js';

const sliderTriggerWidth = 1025;
const menuTriggerWidth = 1067;

window.addEventListener('DOMContentLoaded', run);

async function run(e) {
    initModal({ modalClass: '.privacy', triggerBtnClass: '.privacy-policy' });
    initModal({ modalClass: '.terms', triggerBtnClass: '.terms-of-use' });

    handleFormSubmit({
        selector: '.contact-form',
        uri: 'https://contact.zaia.dev/api/contact',
        configKey: 'domain-dressing'
    });

    window.addEventListener('resize', e => {
        updateSlidesStructure('.project-listing ');
    });

    updateSlidesStructure('.project-listing ');

    handleSlides({
        wrapper: '.project-listing .slider-wrapper',
        nav: '.project-listing .slider-nav'
    });

    document.body.addEventListener('click', e => {
        if (e.target.classList.contains('scroll-to-link')) {
            scrollTo(e);
            toggleMobileMenu(false);
        } else if (e.target.classList.contains('icon-box')) {
            toggleMobileMenu();
        } else if (e.target.classList.contains('dropbtn')) {
            toggleDropDownMenu();
        }
    });
}

function toggleMobileMenu(state) {
    const hasState = typeof state !== 'undefined';
    const header = document.querySelector('.header');
    const condition = hasState ? !!state : !header.classList.contains('nav-visible');

    condition ? header.classList.add('nav-visible') : header.classList.remove('nav-visible');
}

function toggleDropDownMenu(state) {
    if (window.innerWidth < menuTriggerWidth) {
        const hasState = typeof state !== 'undefined';
        const header = document.querySelector('.dropdown');
        const condition = hasState ? !!state : !header.classList.contains('show');

        condition ? header.classList.add('show') : header.classList.remove('show');
    }
}

function scrollTo(e) {
    typeof e.preventDefault === 'function' && e.preventDefault();
    const link = e.target;
    const id = link.href.slice(link.href.lastIndexOf('#') + 1);
    const element = document.getElementById(id);
    // element.scrollIntoView({ behavior: 'smooth' });
    scrollToElement(element);
}

function scrollToElement(element, behavior = 'smooth') {
    const scrollTop =
        window.pageYOffset ||
        (document.documentElement || document.body.parentNode || document.body).scrollTop;
    const finalOffset = element.getBoundingClientRect().top + scrollTop;

    window.scrollTo({
        top: finalOffset,
        behavior
    });
}

function updateSlidesStructure(parentSelector) {
    if (window.innerWidth < sliderTriggerWidth) {
        const itemsPerSlide = 1;
        const items = Array.from(document.querySelectorAll(parentSelector + ' .item')).filter(
            x => x.style.display != 'none'
        );

        while (items.length) {
            // grab 1st itemsPerSlide items and wrap then in <div class="slide">
            const slideChildren = items.splice(0, itemsPerSlide);
            const slide = document.createElement('div');
            slide.classList.add('slide');
            if (slideChildren.length) {
                if (slideChildren[0].parentElement.classList.contains('slide')) {
                    continue;
                }
                slideChildren[0].parentElement.insertBefore(slide, slideChildren[0]);
                for (let i = 0; i < slideChildren.length; i++) {
                    slide.appendChild(slideChildren[i]);
                }
            }
        }
    } else {
        document
            .querySelectorAll(parentSelector + ' .slide')
            .forEach(item => item.replaceWith(...item.childNodes));
    }
}

function handleSlides(params) {
    let activeIndex = 0;
    let touchstartX = 0;
    let touchstartY = 0;
    let touchendX = 0;
    let touchendY = 0;

    const nav = document.querySelector(params.nav);
    const wrapper = document.querySelector(params.wrapper);
    let slides = wrapper.querySelectorAll('.slide');

    slide();

    window.addEventListener('resize', e => {
        slides = wrapper.querySelectorAll('.slide');
        slide();
    });

    wrapper.addEventListener(
        'touchstart',
        event => {
            touchstartX = event.changedTouches[0].screenX;
            touchstartY = event.changedTouches[0].screenY;
        },
        false
    );

    wrapper.addEventListener(
        'touchend',
        event => {
            touchendX = event.changedTouches[0].screenX;
            touchendY = event.changedTouches[0].screenY;
            handleSwipe(event);
        },
        false
    );

    nav.addEventListener('click', e => {
        if (e.target.classList.contains('nav-item')) {
            activeIndex = Array.from(nav.children).indexOf(e.target);
            slide();
        }
    });

    function handleSwipe(e) {
        let caseCaptured = false;

        if (touchendX < touchstartX && Math.abs(touchendX - touchstartX) > 32) {
            // Swipe left
            caseCaptured = true;
            if (activeIndex < slides.length - 1) {
                activeIndex++;
                slide();
            }
        } else if (touchendX > touchstartX && Math.abs(touchendX - touchstartX) > 30) {
            // Swipe right
            caseCaptured = true;
            if (!activeIndex) {
                // If user swipes left and the slider is on the first image -> do nothing
                return;
            }

            activeIndex--;
            slide();
        }

        if (caseCaptured) {
            e.preventDefault();
        }
    }

    function slide() {
        if (window.innerWidth > sliderTriggerWidth) {
            return;
        }

        const idx = activeIndex;

        Array.from(nav.children).forEach((item, i) =>
            idx == i ? item.classList.add('active') : item.classList.remove('active')
        );

        setTimeout(() => {
            if (!slides.length) {
                return;
            }
            const activeSlide = slides[idx];
            const activeSlideW = activeSlide.offsetWidth;
            const parentW = wrapper.offsetWidth / 2;
            const marginLeft =
                idx === 0
                    ? (parentW - activeSlideW / 1.7).toFixed()
                    : (function measure() {
                          let value = 0;
                          for (let i = 0; i < idx; i++) {
                              value += slides[i].offsetWidth;
                          }
                          const margin =
                              parseInt(window.getComputedStyle(slides[0]).marginRight) * 2;
                          const itemsWidth = value + margin * (idx - 1);
                          const x = parentW - (margin + activeSlideW / 2);
                          return -(itemsWidth - x);
                      })();

            slides[0].style.marginLeft = marginLeft + 'px';
        }, 50);
    }
}

function isMobile() {
    const detector = document.querySelector('.mobile-detector');
    const styles = window.getComputedStyle(detector);
    return styles.getPropertyValue('display') === 'none';
}
